import AttachmentResource from '@/api/resources/attachment/attachmentResource'
import { auth } from '@/api/auth'
import { BASE_URL } from '@/api/api'

class PatientAttachmentService extends AttachmentResource {
    async addAttachment(patientId, attachmentTypeId, file, thumbnailBytes) {
        let thumbnail

        if (thumbnailBytes) {
            thumbnail = this.base64ToBlob(thumbnailBytes, file.name)
        } else {
            let generatedThumbnailBytes = await this.thumbnailifyFromBlob(file)
            thumbnail = this.base64ToBlob(generatedThumbnailBytes, file.name)
        }

        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('atyId', attachmentTypeId)

        if (thumbnail) {
            formData.append('thumbnail', thumbnail, file.name)
        }

        const response = await this.axios.post(
            `/common/patients/${patientId}/attachments`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })

        return response.data
    }

    async patchAttachment(patientId, attachmentId, request) {
        const response = await this.axios.patch(`/common/patients/${patientId}/attachments/${attachmentId}`, request)
        return response.data
    }

    async getAttachmentPatientTree(laboratoryId, patientId, withAttachments, withIncidents, isRequest) {
        let params = {
            laboratoryId: laboratoryId,
            withAttachments: withAttachments,
            withIncidents: withIncidents,
            isRequest: isRequest
        }
        const response = await this.axios.get(
            `/patients/${patientId}/hierarchicalPatientTree`,
            { params })
        return response.data
    }

    async getAttachments(patientId, attachmentTypeId) {
        const params = { attachmentTypeId }
        const response = await this.axios.get(`/common/patients/${patientId}/attachments`, { params })
        return response.data
    }

    async getFile(patientId, attachmentId) {
        return this.axios.get(`/common/patients/${patientId}/attachments/${attachmentId}`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }).then(response => response.data)
    }

    getUrlFile(patientId, attachmentId) {
        return `${BASE_URL}/common/patients/${patientId}/attachments/${attachmentId}?authenticationToken=${auth.token}`
    }

    async deleteAttachment(patientId, attachmentId) {
        const response = await this.axios.delete(`/common/patients/${patientId}/attachments/${attachmentId}`)
        return response.data
    }
}

export default new PatientAttachmentService()
